import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Field } from 'redux-form';
import { propBool, propNumber, propStr, propValidate, } from '../../../../helpers/custom-prop-types';
import PlainTextAreaComponent from '../PlainTextAreaComponent';
const PlainTextAreaField = ({ autosized, className, disabled, maxLength, name, placeholder, readOnly, rows, showError, validate, }) => (_jsx(Field, { component: PlainTextAreaComponent, name: name, props: {
        autosized,
        className,
        disabled,
        maxLength,
        placeholder,
        readOnly,
        rows,
        showError,
    }, validate: validate }));
PlainTextAreaField.propTypes = {
    autosized: propBool(),
    className: propStr(),
    disabled: propBool(),
    maxLength: propNumber(),
    name: propStr().isRequired,
    placeholder: propStr(),
    readOnly: propBool(),
    rows: propNumber(),
    showError: propBool(),
    validate: propValidate(),
};
PlainTextAreaField.defaultProps = {
    autosized: false,
    className: 'input-form-text',
    disabled: false,
    maxLength: null,
    placeholder: '',
    readOnly: false,
    rows: undefined,
    showError: true,
    validate: [],
};
export default PlainTextAreaField;
